import Label from "./components/Label";
const { useEffect, useState } = window.wp.element;
const settings = window.wc.wcSettings.getSetting('wkmp_stripe_connect_gateway_data', {
    icon: true,
});
const title = window.wp.htmlEntities.decodeEntities(settings.title) || window.wp.i18n.__('Stripe - Credit Card', 'wkmp-stripe-connect');
var stripe_nonce_field = 'wkmp_stripe_connect_credit_card_block_nonce';

const description = window.wp.htmlEntities.decodeEntities(settings.description) || window.wp.i18n.__('Accept credit card payments with stripe.', 'wkmp-stripe-connect');

const icon = settings.icon ? settings.icon : false;
const StripeConnectContent = (props) => {
    const { eventRegistration, emitResponse, shouldSavePayment } = props;
    const [stripe, setStripe] = useState(null);
    const [elements, setElements] = useState(null);
    const [cardNumber, setCardNumber] = useState(null);
    const [cardExpiry, setCardExpiry] = useState(null);
    const [cardCvc, setCardCvc] = useState(null);
    const [error, setError] = useState('');

    // Initialize Stripe Elements
    useEffect(() => {
        if (!window.Stripe || !window.wkmp_stripe_connect_util) return;

        const stripeInstance = window.Stripe(
            window.wkmp_stripe_connect_util.stripe_publishable_key
        );

        const elementsInstance = stripeInstance.elements({
            currency: window.wkmp_stripe_connect_util.currency.toLowerCase(),
            appearance: {
                theme: 'stripe',
                variables: {
                    colorPrimary: '#007cba',
                    colorBackground: '#ffffff',
                    colorText: '#32325d',
                    borderRadius: '4px',
                    fontFamily: 'inherit'
                }
            }
        });

        const cardNumberElement = elementsInstance.create('cardNumber');
        const cardExpiryElement = elementsInstance.create('cardExpiry');
        const cardCvcElement = elementsInstance.create('cardCvc');

        cardNumberElement.mount('#wkmp-stripe-card-number-block');
        cardExpiryElement.mount('#wkmp-stripe-card-expiry-block');
        cardCvcElement.mount('#wkmp-stripe-card-cvc-block');

        // Auto-focus handling
        cardNumberElement.on('change', (e) => {
            if (e.complete) cardExpiryElement.focus();
            handleElementChange(e);
        });

        cardExpiryElement.on('change', (e) => {
            if (e.complete) cardCvcElement.focus();
            handleElementChange(e);
        });

        cardCvcElement.on('change', handleElementChange);

        setStripe(stripeInstance);
        setElements(elementsInstance);
        setCardNumber(cardNumberElement);
        setCardExpiry(cardExpiryElement);
        setCardCvc(cardCvcElement);

        return () => {
            cardNumberElement.unmount();
            cardExpiryElement.unmount();
            cardCvcElement.unmount();
        };
    }, []);

    // Handle payment processing
    useEffect(() => {
        if (!stripe || !cardNumber) return;

        const unsubscribe = eventRegistration.onPaymentProcessing(async () => {
            try {
                const paymentMethodData = {
                    type: 'card',
                    card: cardNumber,
                    billing_details: props.billingData
                };

                const { paymentMethod, error: pmError } = await stripe.createPaymentMethod(paymentMethodData);

                if (pmError) throw pmError;

                return {
                    type: emitResponse.responseTypes.SUCCESS,
                    meta: {
                        paymentMethodData: {
                            stripe_payment_id: paymentMethod.id,
                            wkmp_stripe_block_nonce: window.wkmp_stripe_connect_util.block_nonce,
                            [stripe_nonce_field]: window.wkmp_stripe_connect_util.card_block_nonce,
                            save_payment_method: shouldSavePayment,
                            setup_future_usage: shouldSavePayment ? 'off_session' : 'none'
                        }
                    }
                };
            } catch (err) {
                return {
                    type: emitResponse.responseTypes.ERROR,
                    message: err.message || 'Payment processing failed'
                };
            }
        });

        return () => unsubscribe();
    }, [stripe, cardNumber, eventRegistration, emitResponse]);

    const handleElementChange = (event) => {
        setError(event.error?.message || '');
    };

    return (
        <div className="wkmp-stripe-connect-block-wrapper">
            <p className="content"><strong>{window.wp.i18n.__('Test mode:', 'wkmp-stripe-connect')}</strong> {window.wp.i18n.__('use the test VISA card', 'wkmp-stripe-connect')} <b>4242424242424242</b> {window.wp.i18n.__('with any expiry date and CVC. Other payment methods may redirect to a Stripe test page to authorize payment. More test card numbers are listed', 'wkmp-stripe-connect')} <a href="https://docs.stripe.com/testing" target="_blank">{window.wp.i18n.__('here', 'wkmp-stripe-connect')}</a>.</p>
            {/* Add nonce field */}
            <input type="hidden" name={stripe_nonce_field} id={stripe_nonce_field} value={window.wkmp_stripe_connect_util.card_block_nonce} />
            <div className="wkmp-stripe-connect-block">
                <div className="p-PaymentAccordionButtonIconWrapper">
                    <div className="p-PaymentAccordionButtonIconContainer">
                        <svg className="p-Icon p-Icon--card Icon p-Icon--md TabIcon p-PaymentAccordionButtonIcon TabIcon--selected" role="presentation" fill="var(--colorIcon)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4a2 2 0 012-2h12a2 2 0 012 2H0zm0 2v6a2 2 0 002 2h12a2 2 0 002-2V6H0zm3 5a1 1 0 011-1h1a1 1 0 110 2H4a1 1 0 01-1-1z"></path>
                        </svg>
                    </div>
                    <div className="p-PaymentAccordionButtonText">
                        <div className="p-CardText">
                            <div>{window.wp.i18n.__('Card', 'wkmp-stripe-connect')}</div>
                        </div>
                    </div>
                </div>
                <div className="form-row">
                    <label>{window.wp.i18n.__('Card Number', 'wkmp-stripe-connect')}</label>
                    <div id="wkmp-stripe-card-number-block" className="stripe-element"></div>
                </div>

                <div className="form-row form-row--split">
                    <div>
                        <label>{window.wp.i18n.__('Expiration Date', 'wkmp-stripe-connect')}</label>
                        <div id="wkmp-stripe-card-expiry-block" className="stripe-element"></div>
                    </div>

                    <div>
                        <label>{window.wp.i18n.__('CVC', 'wkmp-stripe-connect')}</label>
                        <div id="wkmp-stripe-card-cvc-block" className="stripe-element"></div>
                    </div>
                </div>

                {error && <div className="stripe-error-message">{error}</div>}
            </div>
        </div>
    );
};

const WrappedStripeContent = (props) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [validationMessage, setValidationMessage] = useState('');
    const [checkResponse, setCheckResponse] = useState(null);

    const check_single_seller_checkout = async (pay_method) => {
        try {
            const response = await fetch(window.wkmp_stripe_connect_util.ajax_url, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json'
                },
                body: new URLSearchParams({
                    action: 'wkmp_stripe_check_for_single_seller_order',
                    nonce: window.wkmp_stripe_connect_util.nonce,
                    pay_method: pay_method
                })
            });

            if (!response.ok) throw new Error('Network response was not ok');

            return await response.json();
        } catch (error) {
            return { success: false, message: 'Validation check failed' };
        }
    };

    useEffect(() => {
        const validateCheckout = async () => {
            try {
                const { stripe_charge_type } = window.wkmp_stripe_connect_util;
                const response = await check_single_seller_checkout(stripe_charge_type);

                setCheckResponse(response);

                if (!response.single_seller && 'separate_transfers' !== stripe_charge_type) {
                    setValidationMessage(response.message || window.wkmp_stripe_connect_util.stripe_single_seller_supported);
                }
            } catch (error) {
                setValidationMessage('Unable to validate cart contents');
            } finally {
                setIsLoaded(true);
            }
        };

        validateCheckout();
    }, []);

    if (!isLoaded) {
        return <div>Loading payment method...</div>;
    }

    if (validationMessage) {
        return (
            <div id='wkmp_stripe_seller_count_block_notice' className="stripe-validation-message">
                {validationMessage}
            </div>
        );
    }

    return <StripeConnectContent {...props} />;
};

const Stripe_Credit_Card_Block_Gateway = {
    name: 'wkmp_stripe_connect_gateway',
    id: 'wkmp_stripe_connect_gateway',
    label: <Label text={window.wp.i18n.__('Stripe - Credit Card', 'wkmp-stripe-connect')} name="credit_card" image={icon} />,
    ariaLabel: window.wp.i18n.__('Stripe Connect Credit Card', 'wkmp-stripe-connect'),
    title: title,
    description: description,
    icon: icon,
    content: Object(window.wp.element.createElement)(WrappedStripeContent),
    edit: Object(window.wp.element.createElement)(WrappedStripeContent),
    canMakePayment: () => true,
    supports: {
        features: settings.supports,
        showSavedCards: true,
        showSaveOption: true,
    },
};

window.wc.wcBlocksRegistry.registerPaymentMethod(Stripe_Credit_Card_Block_Gateway);
